// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1MJwQ","title":"InfoRow_title__3mivf"};